import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormSelect } from '../../../../StyledComponents';
import { Options } from '../SelectOptions';
import { checkRequiredText, checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    applicationFor: checkRequiredText(settings),
    fieldOfActivity1: checkRequiredText(settings),
    fieldOfActivity2: checkText(settings),
});

export const ApplicationForSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId='applicationFor'>
                <Form.Label>Bewerbung für*</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name='applicationFor'
                    value={values.applicationFor}
                    isValid={touched.applicationFor && !errors.applicationFor}
                    isInvalid={touched.applicationFor && errors.applicationFor}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.ApplicationFor.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.applicationFor}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='fieldOfActivity1'>
                <Form.Label>Tätigkeitsbereich erste Präferenz*</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name='fieldOfActivity1'
                    value={values.fieldOfActivity1}
                    isValid={touched.fieldOfActivity1 && !errors.fieldOfActivity1}
                    isInvalid={touched.fieldOfActivity1 && errors.fieldOfActivity1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.FieldOfActivity.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.fieldOfActivity1}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='fieldOfActivity2'>
                <Form.Label>Tätigkeitsbereich zweite Präferenz</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name='fieldOfActivity2'
                    value={values.fieldOfActivity2}
                    isValid={touched.fieldOfActivity2 && !errors.fieldOfActivity2}
                    isInvalid={touched.fieldOfActivity2 && errors.fieldOfActivity2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.FieldOfActivity.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.fieldOfActivity2}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='preferredLocation1'>
                <Form.Label>Standort erste Präferenz</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name='preferredLocation1'
                    value={values.preferredLocation1}
                    isValid={touched.preferredLocation1 && !errors.preferredLocation1}
                    isInvalid={touched.preferredLocation1 && errors.preferredLocation1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.PreferredLocation.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.preferredLocation1}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='preferredLocation2'>
                <Form.Label>Standort zweite Präferenz</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name='preferredLocation2'
                    value={values.preferredLocation2}
                    isValid={touched.preferredLocation2 && !errors.preferredLocation2}
                    isInvalid={touched.preferredLocation2 && errors.preferredLocation2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.PreferredLocation.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.preferredLocation2}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};